import React, { useState, useContext, useCallback } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import LanguageDropdown from './components/buttons/LanguageDropdown';
import { GameContext } from './GameContext';
import { API_URL } from './config';

const Layout = ({ auth, onSignOut }) => {
    const token = auth.user?.access_token;

    const [navbarColor, setNavbarColor] = useState('linear-gradient(to right, #4e54c8, #757ad4)');
    const { onLanguageChange: contextLanguageChange, triggerGameEndIfActive, 
      isGameActive, updateFlagImageUrl,updateResultsWord, updateGrammarOptions, 
      loadLanguageData, loadUsersLearnedWords, loadTips  } = useContext(GameContext);
    console.log('API URL being used:', API_URL);

    //logic used for rendering the background image only if homepage is in use
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const backgroundStyle = isHomePage ? {
      //backgroundImage: `url('/static/images/WhiteBackground')`,
      //backgroundSize: 'cover',
      //backgroundPosition: 'center',
      //backgroundRepeat: 'no-repeat',
      backgroundColor: '#fafafa',
      minHeight: '100%'
    } : {};
   
    const handleOptionSelect = useCallback((languageCode) => {
      
      console.log(`Selected option: ${languageCode}`);

        (async () => {
          try {
            const response = await fetch(`${API_URL}/api/change_language`,{
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({
                option: languageCode
              }),
            });
            console.log('Response status:', response.status);

            if (!response.ok) {
              const errorData = await response.json();
              console.log('Full error response:', errorData);
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (data.nav_gradient) {
              setNavbarColor(data.nav_gradient);
            } else {
              throw new Error('nav_gradient not found in response');
            }
            updateFlagImageUrl(data.flag_image);
            updateResultsWord(data.results_word);
            updateGrammarOptions(data.grammar_options)
            loadLanguageData(data.vocab_words)
            console.log('loading learned words from database')
            loadUsersLearnedWords(data.learned_words)
            loadTips(data.tips_list)
            
            // Call the context's language change function
            contextLanguageChange(languageCode);

            // If a game is active, trigger the game end
            if (isGameActive) {
              triggerGameEndIfActive();
            }

          } catch (error) {
            console.error('Error fetching gradient colors:', error);
            }
        })();
    }, [contextLanguageChange, triggerGameEndIfActive, isGameActive, updateFlagImageUrl, updateResultsWord, updateGrammarOptions]);

  return (
    <div className="d-flex flex-column min-vh-100"
    style={backgroundStyle}loading="lazy">
      <nav className="navbar navbar-expand-md navbar-dark bg-dark" style={{ background: navbarColor }}>
        <div className="container-fluid">
          <Link className="navbar-brand d-flex align-items-center fw-normal fontdiner-swanky-regular" to="/">&nbsp;&nbsp;Lingoppia</Link>
          <button className="navbar-toggler navbar-dark text-white fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link fw-bold" to="/">Home</Link>
              </li>
                <LanguageDropdown onSelectLanguage={handleOptionSelect} />
              <li className="nav-item dropdown">
                <button className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                  Learn
                </button>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  <li><Link className="dropdown-item" to="/vocabulary">Vocabulary</Link></li>
                  <li><Link className="dropdown-item" to="/grammar">Grammar Trainer</Link></li>
                  <li><Link className="dropdown-item" to="/lessons">Lessons</Link></li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link fw-bold" to="/about">About</Link>
              </li>
              {!auth.isAuthenticated && (
                <li className="nav-item">
                  <Link 
                    className="nav-link fw-bold" 
                    to="/login"
                    onClick={(e) => {
        
                      e.preventDefault();
                      auth.signinRedirect().catch(err => {
                        console.error('Authentication redirect failed:', err);
                      });
                    }}
                  >
                    Login
                  </Link>
                </li>
              )}
              {auth.isAuthenticated && (
                <>
                  <li className="nav-item">
                    <span className="nav-link">Welcome, {auth.user?.profile['cognito:username']}</span>
                  </li>
                  <li className="nav-item">
                    <Link 
                      className="nav-link fw-bold text-secondary" 
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        auth.removeUser();
                      }}
                    >
                      Logout
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <main className="container flex-grow-1 my-4" style={{ maxWidth: '1200px' }}>
        <Outlet />
      </main>

      <footer className="bg-dark text-white py-3">
        <div className="container text-center">
          <p className="mb-0">&copy; 2025 Lingoppia Language App</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;